import { render, staticRenderFns } from "./MonthlyWorkingHours.vue?vue&type=template&id=22a8f410&"
import script from "./MonthlyWorkingHours.vue?vue&type=script&lang=js&"
export * from "./MonthlyWorkingHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports